var $49e000b528331854$exports = {};
$49e000b528331854$exports = {
    "collapse": `Colapsar`,
    "expand": `Expandir`
};


export {$49e000b528331854$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
